import { createSlice } from "@reduxjs/toolkit";
import { getShadeNumberList } from "../../reduxApi/admin/ShadeReduxApi";

const shadeSlice = createSlice({
    name: 'shade',
    initialState: {
        status: 'idel',
        isFiltered: false,
        shade: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteShadeAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.shade.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.shade.splice(index, 1);
                }
            });
        },
        updateShadeAction: (state, action) => {
            const index = state.shade.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.shade.splice(index, 1, { shades: action.payload })
            }
        },
        addShadeAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.shade.unshift({ shades: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getShadeNumberList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getShadeNumberList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.shade = action.payload.data.shades;
            })
    }
})
export const { deleteShadeAction, updateShadeAction, addShadeAction, setFilteredStatus } = shadeSlice.actions
export default shadeSlice.reducer